import React from "react";
import styled from "styled-components";
import {
  TableViewMode,
  useIsCardView,
  useTableViewStore,
} from "../../stores/useTableViewStore";

const Group = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 12px;
  padding: 2px;
  border: 1px solid #dbe3eb;
  border-radius: 8px;
`;

const ToggleButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: ${({ $active }) => ($active ? "#f2f4ff" : "transparent")};
  color: ${({ $active }) => ($active ? "#13273f" : "#8181a5")};
  cursor: pointer;
`;

const TableIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <line x1="3" y1="15" x2="21" y2="15" />
    <line x1="10" y1="10" x2="10" y2="20" />
  </svg>
);

const CardsIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <rect x="3" y="3" width="18" height="7" rx="2" />
    <rect x="3" y="14" width="18" height="7" rx="2" />
  </svg>
);

const options: Array<{
  mode: TableViewMode;
  label: string;
  icon: React.ReactNode;
}> = [
  { mode: "table", label: "Table view", icon: <TableIcon /> },
  { mode: "cards", label: "Card view", icon: <CardsIcon /> },
];

export const TableViewToggle = () => {
  const isCardView = useIsCardView();
  const setViewMode = useTableViewStore((state) => state.setViewMode);
  const activeMode: TableViewMode = isCardView ? "cards" : "table";

  return (
    <Group role="group" aria-label="Table view">
      {options.map(({ mode, label, icon }) => (
        <ToggleButton
          key={mode}
          type="button"
          title={label}
          aria-label={label}
          aria-pressed={activeMode === mode}
          $active={activeMode === mode}
          onClick={() => setViewMode(mode)}
        >
          {icon}
        </ToggleButton>
      ))}
    </Group>
  );
};
